"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _date = require("@ha/date");

var _getExclusion = _interopRequireDefault(require("./exclusionDate/getExclusion"));

var _Listing = require("../constants/Listing");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/* eslint-disable no-underscore-dangle */


var normalizeListing = function normalizeListing(_a) {
  var currency = _a.currency,
      currencyRate = _a.currencyRate;
  return function (item) {
    var photos = item.photos || [];
    photos = photos.map(function (photo) {
      var formattedPhotos = photo.replace('.com/images', '.com/v2/images');
      formattedPhotos = formattedPhotos.replace("kind=" + _Listing.ListingPhotoKind.Large, "kind=" + _Listing.ListingPhotoKind.SearchPagePreview);
      return formattedPhotos;
    });
    return __assign(__assign({}, item), {
      // TODO: Refactor components so only one id is used
      id: item.internalID,
      entityId: item.internalID,
      advertiser: {
        avatarURL: item.advertiserAvatar
      },
      currency: currency,
      listingPath: item.path,
      previewImage: item.thumbnailURL,
      price: Math.round(currencyRate * item.priceEUR * 100),
      minPrice: Math.round(currencyRate * item.minPrice),
      isNew: Date.now() - item.creationDateTS * 1000 < _date.WEEK_IN_MS,
      minimalRentalPeriod: item.minimumStayMonths,
      exclusions: [(0, _getExclusion["default"])(item.dateFrom, item.dateTo)],
      latitude: item._geoloc && item._geoloc.lat || null,
      longitude: item._geoloc && item._geoloc.lng || null,
      photos: photos
    });
  };
};

var _default = normalizeListing;
exports["default"] = _default;